const X_COMPLETION_KEY = 'x_auth_completion';

export function buildXAuthStartUrl(returnUrl, source) {
	const base = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
	const params = new URLSearchParams();
	if (returnUrl) params.set('returnUrl', returnUrl);
	params.set('source', source || 'login');
	return `${base}/auth/x/start?${params.toString()}`;
}

export function buildXCompleteUrl(returnUrl, verification = false) {
	const params = new URLSearchParams();
	if (returnUrl) params.set('returnUrl', returnUrl);
	if (verification) params.set('verification', '1');
	return `/auth/x/complete?${params.toString()}`;
}

export function storeXCompletionState(state) {
	try {
		sessionStorage.setItem(X_COMPLETION_KEY, JSON.stringify(state));
	} catch (e) {
		// storage unavailable
	}
}

export function clearXCompletionState() {
	try {
		sessionStorage.removeItem(X_COMPLETION_KEY);
	} catch (e) {
		// storage unavailable
	}
}

export function getXCompletionState() {
	try {
		const raw = sessionStorage.getItem(X_COMPLETION_KEY);
		return raw ? JSON.parse(raw) : null;
	} catch (e) {
		return null;
	}
}

export function getXAuthErrorMessage(msg) {
	if (!msg) return 'X sign-in failed. Please try again.';
	return typeof msg === 'string' ? msg : 'X sign-in failed. Please try again.';
}
